import Grid from '@mui/material/Grid';
import ArchiveText from './ArchiveText';
import GetArchiveR1 from './ArchiveCards/GetArchiveR1'
import GetArchiveR2 from './ArchiveCards/GetArchiveR2'
import GetArchiveUbam from './ArchiveCards/GetArchiveUbam';
import GetArchiveCRAM from './ArchiveCards/GetArchiveCRAM';
import GetArchiveCRAI from './ArchiveCards/GetArchiveCRAI';
import GetArchiveVcf from './ArchiveCards/GetArchiveVcf';
import GetArchiveVcfIndex from './ArchiveCards/GetArchiveVcfIndex';
import SectionStructure from '../../../../components/Section/SectionStructure';


export default function SectionArchive() {

    
    return (

         <SectionStructure
            
                    sectiontext=    { <ArchiveText /> }
        
                    sectioncards=  {<>

                    <Grid container>
                        <Grid >  <GetArchiveR1 />  </Grid>
                        <Grid >  <GetArchiveR2 />  </Grid>
                        <Grid >  <GetArchiveUbam /> </Grid>
                        <Grid >  <GetArchiveCRAM />  </Grid>
                        <Grid >  <GetArchiveCRAI /> </Grid>
                        <Grid >  <GetArchiveVcf />  </Grid>
                        <Grid >  <GetArchiveVcfIndex />  </Grid>
                    </Grid>
                </> }
            />
    )
}